var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('div',{class:'mx-3 vti__flag ' + item.value.toLowerCase()}),_vm._v(" "+_vm._s(item.text)+" ")]}},{key:"item",fn:function(ref){
var item = ref.item;
return [_c('div',{class:'vti__flag ' + item.value.toLowerCase()}),_vm._v(" "+_vm._s(item.text)+" ")]}}]),model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}},'v-autocomplete',_vm.attrs,false),_vm.on))}
var staticRenderFns = []

export { render, staticRenderFns }